module.exports = __webpack_public_path__ + "static/media/oberflex-zebranot13-1200x2490.9549e118.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranot13-1200x2490.jpg
// module id = 1066
// module chunks = 37